import { loadBankLinkageRows } from './loadBankLinkageRows'

let readSequence = 0

export const loadCreatedLinkageRows = async ({ api, businessApi, businessId, libroId, from, to, payload, montoTotal, requestOptions }) => {
  const date = String(payload?.fecha || '').slice(0, 10)
  const bankRows = await loadBankLinkageRows({ api, businessId, libroId, from, to, payload, montoTotal, requestOptions })
  if (!businessApi || !date) return bankRows

  // The bank candidate list can lag behind the linkage module. Read the same
  // authoritative accounting records used by that module before and after creation.
  const summaryResponse = await businessApi.getListSummaryVinculos({
    businessId,
    month: 0,
    year: Number(date.slice(0, 4)),
    limit: 10000,
    _refresh: `${Date.now()}-${++readSequence}`
  }, requestOptions)
  const summaryData = summaryResponse?.data
  const summaryRows = Array.isArray(summaryData)
    ? summaryData
    : summaryData && typeof summaryData === 'object'
      ? Object.values(summaryData).flat()
      : null
  if (!summaryRows) {
    const failure = new Error('No se pudo leer el listado de vinculaciones.')
    failure.code = 'INVALID_LINKAGE_RESPONSE'
    throw failure
  }
  const result = [...bankRows]
  for (const summary of summaryRows) {
    if (!summary || !Number.isFinite(Number(summary.idPrincipal)) || Number(summary.idPrincipal) <= 0) continue
    const index = result.findIndex(row => String(row.idPrincipal ?? row.id) === String(summary.idPrincipal))
    const record = { ...summary, id: summary.id ?? summary.idPrincipal, _creationSource: 'vinculaciones' }
    if (index >= 0) {
      const bankRecord = Object.fromEntries(Object.entries(result[index])
        .filter(([, value]) => value != null && value !== ''))
      result[index] = { ...record, ...bankRecord }
    }
    else result.push(record)
  }
  return result
}
